import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarProdutosCadastradosUltimos30DiasDashboard(axios, parametros) {
    parametros.operacao = 'buscarProdutosCadastradosUltimos30DiasDashboard';

    let retorno = {};
    await axios.santriGET('/rest/produto', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data); 
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RProduto/RProdutoBuscarProdutosCadastradosUltimos30DiasDashboard.js